import {useMediaQuery} from '@material-ui/core';
import React, {createContext, useEffect, useState} from 'react';

const AppCtx = createContext({});

const AppContext = ({children, appConfig}) => {
    const [config] = useState(appConfig);
    const [inForm, setInFormState] = useState(false);
    const [tankermanId, setTankermanId] = useState(null);
    const [snackOpen, setSnackOpen] = useState(false);
    const [snackProps, setSnackProps] = useState({
        severity: null,
        message: null,
    });
    const [formRedirect, setFormRedirect] = useState(false);
    const [showWelcomeTutorial, setShowWelcomeTutorial] = useState(false);
    const prefersDarkMode = useMediaQuery('(prefers-color-scheme: dark)');
    const darkModeCached = window.localStorage.getItem('darkMode');
    const [darkMode, setDarkMode] = useState(
        darkModeCached !== undefined
            ? darkModeCached === 'true'
            : prefersDarkMode
    );

    useEffect(() => {
        window.localStorage.setItem('darkMode', `${darkMode}`);
    }, [darkMode]);

    const setInForm = flag => {
        setInFormState(flag);
    };

    return (
        <AppCtx.Provider
            displayName='App'
            value={{
                inForm,
                setInForm,
                tankermanId,
                setTankermanId,
                snackOpen,
                setSnackOpen: open => setSnackOpen(open),
                snackProps,
                setSnackProps: props => setSnackProps(props),
                formRedirect,
                setFormRedirect,
                config,
                darkMode,
                setDarkMode,
                showWelcomeTutorial,
                setShowWelcomeTutorial,
            }}
        >
            {children}
        </AppCtx.Provider>
    );
};

const withAppContext = Component => props => {
    return <AppContext>{React.createElement(Component, props)}</AppContext>;
};

export default AppContext;
export {AppCtx, withAppContext};
